import { z } from 'zod';
import { MediaItemSchema } from "../../api/media-item-schema";
import { ApiResponseSchema } from "../../api/api-response-schema";

export const PartnerSchema = z.object({
  id: z.number(),
  name: z.string(),
  color: z.string(),
  logo: MediaItemSchema.nullable().optional()
});

export type Partner = z.infer<typeof PartnerSchema>;
const PartnerPreviewArraySchema = z.array(PartnerSchema);

export type PartnerResponse = z.infer<typeof PartnerResponseSchema>;


export const PartnerResponseSchema = ApiResponseSchema(
  z.array(PartnerSchema),
);

export type PartnerSchemaKey = keyof typeof PartnerSchema.shape;

export const PartnerParams = <const>{
  populate: <PartnerSchemaKey[]>['logo'],
  fields: <PartnerSchemaKey[]>[
    'id',
    'name',
    'color'
  ],
};
